(() => {
  if (window.urbanBotaniksConsentReady) return;
  window.urbanBotaniksConsentReady = true;
  let cartAccepted = false;
  let queued = false;
  const cartInputs = () => document.querySelectorAll('[data-ub-cart-consent]');
  const missing = form => form && Array.from(form.elements).find(input => input.matches?.('[data-ub-policy-required]') && !input.checked);
  const sync = () => {
    queued = false;
    cartInputs().forEach(input => { if (input.checked !== cartAccepted) input.checked = cartAccepted; });
    document.querySelectorAll('[data-ub-policy-controls]').forEach(group => {
      const form = document.getElementById(group.dataset.consentForm);
      const locked = !form || !Array.from(form.elements).some(input => input.matches?.('[data-ub-cart-consent]')) || !cartAccepted;
      if (group.disabled !== locked) group.disabled = locked;
    });
    document.querySelectorAll('[data-ub-policy-express]').forEach(group => {
      const form = document.getElementById(group.dataset.consentForm);
      const locked = !form || !Array.from(form.elements).some(input => input.matches?.('[data-ub-cart-consent]')) || !cartAccepted;
      group.hidden = locked;
      group.inert = locked;
    });
  };
  const schedule = () => { if (!queued) { queued = true; queueMicrotask(sync); } };
  const stop = (event, input) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!input) return;
    input.setCustomValidity(input.dataset.requiredMessage || '');
    input.reportValidity();
    input.focus({preventScroll:false});
  };
  const guardCheckout = event => {
    const button = event.target instanceof Element ? event.target.closest('[data-ub-policy-checkout]') : null;
    if (!button) return;
    const form = button.form || document.getElementById(button.getAttribute('form'));
    const input = missing(form);
    if (!form || input) stop(event, input);
  };
  ['pointerup','mouseup','touchend','click'].forEach(type => window.addEventListener(type, guardCheckout, true));
  window.addEventListener('submit', event => {
    const input = missing(event.target);
    if (input) stop(event, input);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-ub-policy-required]')) return;
    event.target.setCustomValidity('');
    if (event.target.matches('[data-ub-cart-consent]')) {
      cartAccepted = event.target.checked;
      cartInputs().forEach(input => input.setCustomValidity(''));
    }
    sync();
  });
  document.addEventListener('reset', event => {
    if (Array.from(event.target.elements || []).some(input => input.matches?.('[data-ub-cart-consent]'))) cartAccepted = false;
    schedule();
  });
  const init = () => {
    sync();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
